import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class LoginState extends BaseRootOption {
  static label = "Login State";
  static descriptionMessage = "This will simulate the way this component will look when the user is logged in or out";
  static userInterfaceComponent = {
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Logged In",
          value: "Logged In",
        },
        {
          label: "Logged Out",
          value: "Logged Out",
        },
      ],
    },
  };

  static defaultValue = "Logged In";
}
